<template>
    <div>
        <div v-if="logeado=='no'">
            <v-sheet color="#6f263d" rounded="xl" height="65" dark>
                <v-container>
                    <v-row class="mt-0">
                        <v-col cols="6" class="text-start">
                            <v-icon>shopping_cart</v-icon>
                            <strong> Ecommerce BodegaNet</strong>
                        </v-col>
                        <v-col cols="6" class="text-end">
                            <h3>BIENVENIDO</h3>
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
            <div class="box">
                <v-row>
                    <v-col class="text.center" cols="12" md="12">
                        <strong>Acceso</strong>
                    </v-col>
                    <v-col class="text-center" cols="12" md="12" >
                        <v-text-field class="text-body-2" v-model="contrato" label="Contrato" outlined dense rounded disabled></v-text-field>
                    </v-col>
                    <v-col class="text-center" cols="12" md="12" >
                        <v-text-field class="text-body-2" v-model="login" label="Usuario" outlined dense rounded></v-text-field>
                    </v-col>
                    <v-col class="text-center" cols="12" md="12" >
                        <v-text-field class="text-body-2" v-model="clave" label="Clave" outlined dense rounded></v-text-field>
                    </v-col>
                    <v-col class="text-center" cols="12" md="12" >
                        <v-btn @click="ingresar()" color="teal" small rounded dark>Ingresar</v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-if="logeado=='si'">
            <component v-bind:is="componente"></component>        
        </div>
        <div v-if="logeado==''" class="iniciando">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Iniciando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>

        <!-- dialogo cambia password -->
        <v-dialog v-model="dialog" max-width="300" persistent>
        <v-card>
            <v-card-title>
            <v-row>
                <v-col cols="8" md="10">
                Cambiar Contraseña
                </v-col>
                <v-col cols="4" md="2" class="text-end">
                <v-btn @click="dialog=false" text icon>
                    <v-icon color="red">close</v-icon>
                </v-btn>
                </v-col>
            </v-row>
            </v-card-title>
            <v-card-text>
                <h2>Hola {{ login }}</h2>
            <v-form class="mt-5">
                <v-text-field v-model="password1" label="New Password" 
                    :append-icon="showPass ? 'visibility' : 'visibility_off'"
                    @click:append="showPass = !showPass"
                    required
                    outlined
                    dense
                    rounded
                    :type="showPass ? 'text' : 'password'"
                ></v-text-field>
                <v-text-field v-model="password2" label="Confirmar" 
                    :append-icon="showPass ? 'visibility' : 'visibility_off'"
                    @click:append="showPass = !showPass"
                    required
                    outlined
                    dense
                    rounded
                    :type="showPass ? 'text' : 'password'"
                ></v-text-field>
                <div class="text-center">
                    <v-btn class="signin-btn" dense rounded color="teal" dark @click='CambiaPassword()'>Cambiar</v-btn>
                </div>
            </v-form>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.box {
    width: 250px;
    height: 250px;
    margin-top: 7%;
    margin-left: 40%
}
.iniciando {
    width: 250px;
    height: 250px;
    margin-top: 20%;
    margin-left: 40%
}
</style>
<script>
import Acceso from "@/components/Acceso.vue";
import axios from "axios";
export default {
  name: 'Login',
  components:{Acceso},
  data: () => ({
    snack:false,
    color_snack:'',
    mensaje:'',
    logeado:'',
    componente:'Acceso',
    contrato:'sys_ecommerce',
    user:null,
    apikey:null,
    login:'',
    clave:'',
    dialog:false,
    password1:'',
    password2:'',
    showPass:false,
  }),
  async mounted(){
    //validamos el contrato
    localStorage.setItem('contrato', this.contrato);
    //const myContrato = await this.validaContrato();
    const myContrato = true;
    if(myContrato){
        this.user=localStorage.getItem('user');
        this.apikey=localStorage.getItem('apiKey');
        if(this.user!=null && this.apikey!=null){
            this.logeado='si'
        } else {
            this.logeado='no'
        }
    } else {
        this.logeado='no'
    }
  },
  methods:{
    async validaContrato(){
        let result = false;
        try {
            const params={ contrato: this.contrato };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/contratos/',params);
            const datos = res.data;
            if(datos[0].existe=='si'){
                localStorage.setItem('contrato', datos[0].contrato);
                return true
            }            
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async ingresar(){
        try {
            //obtener token de sesion
            const paramsToken = {
                contrato : this.contrato,
                user :  this.login
            };
            const resToken = await axios.post(process.env.VUE_APP_URL + '/api/v1/create/token/',paramsToken);
            const dataToken = resToken.data;
            this.apikey = dataToken.Token;
            localStorage.setItem('apiKey', dataToken.Token);
            //validamos al usuario con el token creado
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const paramsLogin = {
                contrato : this.contrato,
                user :  this.login,
                pass : this.clave
            };
            const resLogin = await axios.post(process.env.VUE_APP_URL + '/api/v1/login/',paramsLogin,{headers});
            const dataLogin = resLogin.data;
            if(dataLogin[0].existe=='si'){
                if(dataLogin[0].clave!='123456'){
                    //localStorage.setItem('user', dataLogin[0].usuario);
                    localStorage.setItem('user',this.login);
                    this.logeado='si'
                } else {
                    this.dialog=true
                }
            } else {
                this.logeado='no'
                this.mensaje='login invalido';
                this.color_snack='red';
                this.snack=true;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async CambiaPassword(){
        if(this.login!='' && this.password1!='' && this.password2!=''){
            if(this.password1!=this.password2){
                this.mensaje='Las claves no coinciden';
                this.color_snack='error';
                this.snack=true;
            } else {
                try {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const paramsLogin = {
                        contrato : this.contrato,
                        user :  this.login,
                        pass : this.password1
                    };
                    const resLogin = await axios.post(process.env.VUE_APP_URL + '/api/v1/password/',paramsLogin,{headers});
                    const dataLogin = resLogin.data;
                    if(dataLogin[0].existe=='si'){
                        this.mensaje='Tu clave fue cambiada con exito';
                        this.color_snack='success';
                        this.snack=true;
                    }
                } catch (error) {
                    console.log(error)
                    this.mensaje='Algo salio mal, intentelo mas tarde';
                    this.color_snack='error';
                    this.snack=true;
                }
            }
        } else {
            this.mensaje='Ingresa los datos requeridos';
            this.color_snack='error';
            this.snack=true;
        }
    }



  }
}
</script>
